export default __webpack_public_path__ + "static/media/icon-footer-linkedin.b5db2fbc.svg";